import api, { version } from "@/api/axios";
import md5 from "js-md5";
import storeCallback from "../../utils/storeCallback";

export default {
	state: {
		auth: false,
		settings: {},
		branch: {
			id: 0,
			name: '',
			address: '',
		},
		error: '',
		codeFlag: false
	},
	
	getters: {
		// Добавим геттер для auth, так как ваш миксин подписок и компонент его используют
		auth: state => state.auth,
		branchSettings: state => state.settings,
		authError: state => state.error,
		authCodeFlag: state => state.user.codeFlag,
		authBranch: state => state.user.branch,
	},
	
	actions: {
		login({ commit }, data) {
			if (!data.userPass && !data.clientEmail && !data.clientPhone && !data.userLogin && !data.clientCode) {
				commit("setAuthError", 'Заполните обязательные поля');
				if (typeof storeCallback === 'function') storeCallback(data);
			} else {
				// Создаем копию данных, чтобы не мутировать исходный объект
				const requestData = { ...data };
				if (requestData.userPass) {
					requestData.userPass = String(requestData.userPass).trim();
					requestData.userPass = md5(requestData.userPass);
				}
				
				api.post("/manage/auth/login", requestData)
					.then(response => {
						commit("setAuth", response.data);
						if (typeof storeCallback === 'function') storeCallback(data, response.data);
					})
					.catch((err) => {
						console.error(err);
						commit("setAuthError", 'Что-то пошло не так, попробуйте позже.');
						if (typeof storeCallback === 'function') storeCallback(data);
					});
			}
		},
		
		getAuth({ commit }) {
			return api.post(`/manage/auth/auth-status`)
				.then(response => {
					commit("setAuth", response.data);
					return response.data;
				});
		},
		
		logout({ commit, dispatch }, type = '') {
			api.post(`/manage/auth/logout?type=${ type }`).then(response => {
				commit("setAuth", response.data);
				
				// Перед жесткой перезагрузкой страницы закроем сокет
				dispatch('WSConnectionClose', null, { root: true });
				window.location.href = '/auth';
			});
		},
		
		clearAuthError({ commit }) {
			commit("setAuthError", '');
		}
	},
	mutations: {
		setAuthError(state, value = '') {
			state.error = value;
		},
		setAuth(state, rawValue) {
			if (!rawValue) return;
			
			// Глубокое копирование, чтобы не ломать объект ответа сервера
			const value = JSON.parse(JSON.stringify(rawValue));
			
			if (value.groups) {
				value.isTeam = !!value.groups.team;
				value.isAdmin = !!value.groups.admin;
				value.control = !!value.groups.control;
				value.isMaster = !!value.groups.master;
				value.isManager = !!value.groups.manager;
			}
			
			if (value.branch) {
				state.branch = value.branch;
				delete value.branch;
			}
			
			if (value.error) {
				if (value.error.needCode) {
					state.codeFlag = true;
					state.error = value.error.message || '';
				} else {
					state.error = value.error.message || value.error;
				}
				delete value.error;
			} else {
				state.error = '';
			}
			
			state.auth = value;
			
			if (value.settings) {
				state.settings = value.settings;
			}
			
			// Проверка версии приложения (кэш-бастинг)
			// Убедитесь, что переменная `version` глобально доступна
			if (value.version && typeof version !== 'undefined' && value.version !== version) {
				window.location.reload();
			}
		}
	}
};
